export default __webpack_public_path__ + "static/media/017-igloo.6c816fa1.svg";